(ns quuppa.qsm.qpes.view
  "QPEs list"
  (:require [clojure.string :as str]
            [linked.core :as l]
            [quuppa.qsm.permissions :as permissions]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reitit.frontend.easy :as rfe]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.peweb.query :as q]
            [quuppa.peweb.tables :as tables]
            [quuppa.qsm.events :as e]
            [quuppa.qsm.register-qpe.view :as register-qpe]
            [quuppa.qsm.site.events :as se]))

(def managed-qpes-columns
  (l/map
    :name
    {:value-fn :name
     :sortable true
     :width "20%"
     :label "QPE name"}

    :location
    {:value-fn :location
     :sortable true
     :width "20%"
     :label "Location"}

    :project-name
    {:value-fn :project_name
     :sortable true
     :width "20%"
     :label "Project"}

    ;; TODO: Not right place for this
    :version
    {:sortable false
     :weight "30%"
     :label "Version"}

    :status
    {:value-fn :status
     :sortable true
     :width "5%"
     :label "Status"}

    :actions
    {:value-fn :revoke_column
     :sortable false
     :width "10%"
     :label ""}))

(def registrations-columns
  (l/map
    :name
    {:value-fn :name
     :sortable true
     :width "40%"
     :label "QPE name"}

    :location
    {:value-fn :location
     :sortable true
     :width "20%"
     :label "Location"}

    :notes
    {:value-fn :notes
     :sortable false
     :width "40%"
     :label "Notes"}

    :actions
    {:value-fn :revoke_column
     :sortable false
     :width "10%"
     :label ""}))

(rf/reg-sub
  ::sorted-available-managed-qpes
  (fn [_]
    (q/subscribe e/authorized-qpes {} [:result]))
  (fn [qpes [_ sort-key sort-order]]
    (let [column (get managed-qpes-columns sort-key)
          value-fn (:value-fn column)]
      (->> (vals qpes)
           (filter #(nil? (:site-id %)))
           (sort-by (fn [value]
                      (some-> (value-fn value)
                              str/lower-case))
                    (if sort-order compare #(compare %2 %1)))))))

(rf/reg-sub
  ::sorted-in-use-managed-qpes
  (fn [_]
    (q/subscribe e/authorized-qpes {} [:result]))
  (fn [qpes [_ sort-key sort-order]]
    (let [column (get managed-qpes-columns sort-key)
          value-fn (:value-fn column)]
      (->> (vals qpes)
           (filter #(some? (:site-id %)))
           (sort-by (fn [value]
                      (some-> (value-fn value)
                              str/lower-case))
                    (if sort-order compare #(compare %2 %1)))))))

(rf/reg-sub
  ::sorted-registered-qpes
  (fn [_]
    (q/subscribe e/configured-qpes {} [:result]))
  (fn [qpes [_ sort-key sort-order]]
    (let [column (get registrations-columns sort-key)
          value-fn (:value-fn column)]
      (sort-by (fn [value]
                 (some-> (value-fn value)
                         str/lower-case))
               (if sort-order compare #(compare %2 %1))
               (vals qpes)))))

(defn qpe-status-circle [{:keys [status class]}]
  [:div.qi-circle
   (merge-with
     #(str %1 " " %2)
     {:class class}
     (case status
       "preconfigured" {:class "text-warning"
                        :title "Preconfigured"}
       "online" {:class "text-success"
                 :title "Online"}
       "offline" {:class "text-danger"
                  :title "Offline"}
       "health_check_failed" {:title "Unreachable"}
       "upgrading" {:class "text-warning"
                    :title "Upgrading"}
       {:class "text-danger"
        :title (str "Unknown status: " status)}))])

(defn qpe-row [{qpe-identity :identity, qpe-status :status qpe-name :name project-name :project_name :as qpe}
               {:keys [manage? action disconnect-engine?]}]
  [:tr.cursor-pointer
   {:data-test-qpe-name qpe-name
    :on-click (fn [_]
                (when manage?
                  (if (= "online" qpe-status)
                    (rfe/push-state :qpe-info {:qpe-identity qpe-identity})
                    (rf/dispatch [:qpe-register/edit-qpe qpe]))))}
   [:td [:span (or qpe-name
                   (:identity qpe))]]
   [:td (:location qpe)]
   [:td project-name]
   [:td (:version qpe)]
   [:td.text-center.qpe-status
    [qpe-status-circle {:status qpe-status}]]
   (when (or action manage?)
     [:td
      {:on-click (fn [e]
                   (.stopPropagation e))}
      (or action
          [dropdown/dropdown
           [dropdown/menu-icon-toggle]
           [dropdown/menu
            [dropdown/item
             {:on-click #(rf/dispatch [:qsm/revoke-authorized (:identity qpe)])}
             "Revoke"]
            (when disconnect-engine?
              [dropdown/item
               {:on-click #(rf/dispatch [::se/disconnect-engine (:identity qpe)])}
               "Disconnect engine from site"])]])])])

(defn registered-qpes []
  (let [sort-key (r/atom :name)
        sort-order-asc (r/atom true)]
    (fn []
      (let [sorted-qpes @(rf/subscribe [::sorted-registered-qpes @sort-key @sort-order-asc])
            manage-privilege? (and @(rf/subscribe [:user/has-privilege "users/manage"])
                                   (permissions/has-manage-permission?))]
        [:div.d-flex.flex-column.p-4.flex-shrink-0
         [:div.container.m-0
          [:div.d-flex.flex-row.mb-1
           [:h3.card-title.flex-grow-1
            "Registered"]
           (when manage-privilege?
             [:button.btn.btn-primary
              {:on-click (fn [_]
                           (rf/dispatch [:qpe-register/add-new-qpe]))}
              "Register new QPE"])]

          [:table.table.table-hover.table-bordered.table-striped
           [tables/thead
            {:columns registrations-columns
             :sort-key @sort-key
             :sort-order-asc @sort-order-asc
             :toggle-sort-order (fn [] (swap! sort-order-asc not))
             :set-sort-key (fn [k]
                             (reset! sort-order-asc true)
                             (reset! sort-key k))}]
           [:tbody
            (for [{:keys [id location notes] qpe-name :name :as qpe} sorted-qpes]
              ^{:key id}
              [:tr.cursor-pointer
               {:on-click (fn [_]
                            (rf/dispatch [:qpe-register/delete-qpe-intent qpe]))
                :data-qpe-id id}
               [:td qpe-name]
               [:td location]
               [:td notes]
               [:td
                {:on-click (fn [e]
                             ;; Disable opening sidebar if clicking on the dropdown
                             (.stopPropagation e))}
                (when manage-privilege?
                  [dropdown/dropdown
                   [dropdown/menu-icon-toggle]
                   [dropdown/menu
                    [dropdown/item
                     {:on-click #(rf/dispatch [:qsm/delete-qpe id])}
                     "Delete"]]])]])]]]]))))

(defn managed-qpes []
  (let [available-sort-key (r/atom :name)
        available-sort-order-asc (r/atom true)
        in-use-sort-key (r/atom :name)
        in-use-sort-order-asc (r/atom true)]
    (fn []
      (let [manage-privilege? (and @(rf/subscribe [:user/has-privilege "users/manage"])
                                   (permissions/has-manage-permission?))
            sorted-available-qpes @(rf/subscribe [::sorted-available-managed-qpes @available-sort-key @available-sort-order-asc])
            sorted-in-use-qpes @(rf/subscribe [::sorted-in-use-managed-qpes @in-use-sort-key @in-use-sort-order-asc])
            row-props {:manage? manage-privilege?}]
        [:div.d-flex.flex-column.p-4.flex-shrink-0
         [:div.container.m-0
          [:h3.card-title "Available"]
          [:table.table.table-hover.table-bordered.table-striped
           [tables/thead
            {:columns (cond-> managed-qpes-columns
                              (not manage-privilege?) (dissoc :actions))
             :sort-key @available-sort-key
             :sort-order-asc @available-sort-order-asc
             :toggle-sort-order (fn [] (swap! available-sort-order-asc not))
             :set-sort-key (fn [k]
                             (reset! available-sort-order-asc true)
                             (reset! available-sort-key k))}]
           [:tbody
            (for [qpe sorted-available-qpes]
              ^{:key (:id qpe)}
              [qpe-row qpe row-props])]]

          [:h3.card-title "In use"]

          [:table.table.table-hover.table-bordered.table-striped
           [tables/thead
            {:columns (cond-> managed-qpes-columns
                              (not manage-privilege?) (dissoc :actions))
             :sort-key @in-use-sort-key
             :sort-order-asc @in-use-sort-order-asc
             :toggle-sort-order (fn [] (swap! in-use-sort-order-asc not))
             :set-sort-key (fn [k]
                             (reset! in-use-sort-order-asc true)
                             (reset! in-use-sort-key k))}]
           [:tbody
            (for [qpe sorted-in-use-qpes]
              ^{:key (:id qpe)}
              [qpe-row qpe (assoc row-props :disconnect-engine? true)])]]]]))))

(defn qpes-page []
  [:section.section.d-flex.flex-column.flex-grow-1
   [:div.d-flex.flex-row.flex-grow-1
    [:div.content.flex-column.flex-grow-1.scroll-container
     {:class (if @(rf/subscribe [:qpe-register/form])
               "d-none d-sm-flex"
               "d-flex")}
     [registered-qpes]
     [managed-qpes]]
    [register-qpe/sidebar-form]]])

;; Just for frontpage
(def qpes-controller
  {:id :qpes
   :start (fn [_]
            (q/execute e/authorized-qpes {})
            (q/execute e/configured-qpes {})
            nil)
   :subscriptions (fn [_]
                    [[:qpe/add]
                     [:qpe/update]
                     [:qpe/revoked-authorization]
                     [:qpe/status]
                     ;; previously here, these related to e/configured-qpes query
                     [:qpe/deleted]
                     [:qpe/preconfigured]
                     [:qpe/installation-token-refreshed]])})
